import gql from 'graphql-tag'

export const academyArticleSearchQuery = gql`
  query DooerAcademyArticleSearch($q: String!, $filter: String) {
    academy {
      articleSearch(q: $q, filter: $filter) {
        edges {
          node {
            id
            description
            title
            icon
            markdown {
              source
            }
            category {
              id
              title
              icon
            }
          }
        }
      }
    }
  }
`
